import { render, staticRenderFns } from "./originOrdersForm.vue?vue&type=template&id=40e313f1&"
import script from "./originOrdersForm.vue?vue&type=script&lang=js&"
export * from "./originOrdersForm.vue?vue&type=script&lang=js&"
import style0 from "./originOrdersForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports